import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {lastValueFrom} from 'rxjs';
import {EnvironmentService} from '../EnvironmentService';
import {LearnerBadgesResponseDto} from '../../types/LearnerBadgesResponseDto';

@Injectable({
    providedIn: 'root'
})
export class BadgesRessource {

    constructor(private http: HttpClient, private environmentService: EnvironmentService) {
    }

    public async getLearnerBadges(msteamsId: string): Promise<LearnerBadgesResponseDto> {
        return lastValueFrom(this.http.get<LearnerBadgesResponseDto>(`${this.environmentService.environment.serverUrl}/api/profile/badges`, {params: {msteamsid: msteamsId}}));
    }

    public async getLearnerBadgesForLearn(learnerId?: string): Promise<LearnerBadgesResponseDto> {
        const options = learnerId !== undefined ? {params: {learnerid: learnerId}} : undefined;
        return lastValueFrom(this.http.get<LearnerBadgesResponseDto>(`${this.environmentService.environment.serverUrl}/api/learn/profile/badges`, options));
    }
}
